import { NgModule } from '@angular/core';
import { CheckIconComponent } from './check-icon.component';
import { CrossIconComponent } from './cross-icon.component';
import { MaterialModule } from '../../../material.module';
import { SvgIconComponent } from '../../../ui-kit/svg-icon/svg-icon.component';

@NgModule({
  imports: [MaterialModule, SvgIconComponent],
  declarations: [CheckIconComponent, CrossIconComponent],
  exports: [CheckIconComponent, CrossIconComponent],
})
export class IconsModule {}
